import browserStorage from "common/browser-storage";
import { Button } from "components/button";
import Countdown from "components/countdown";
import { CrossIcon } from "icons/cross-icon";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import paths from "routes/paths";
import { useAppSelector } from "store";
import { authNewSelectors } from "store/reducers/auth-new";

import css from "./index.module.scss";

const getLsKeyHide = (id: string) => `promo:${id}:hide`;

const PromoTopAlert = () => {
  const [show, showSet] = useState(true);
  const promo = useAppSelector(authNewSelectors.promoGet);
  const subscription = useAppSelector(authNewSelectors.subscriptionGet);

  useEffect(() => {
    if (promo) {
      showSet(browserStorage.local.getItem(getLsKeyHide(promo.id)) !== "1");
    }
  }, [promo]);

  if (!promo || !show || !!subscription) {
    return null;
  }

  const hide = () => {
    browserStorage.local.setItem(getLsKeyHide(promo.id), "1");
    showSet(false);
  };

  return (
    <div className={css.outer} data-promo-id={promo.id}>
      <Link className={css.inner} to={paths.purchase()}>
        <span
          className={css.title}
          dangerouslySetInnerHTML={{ __html: promo.nameHtml || promo.name }}
        />
        {(promo.descriptionShortHtml || (promo.endAt && promo.timer)) && (
          <span className={css.subtitle}>
            {promo.descriptionShortHtml && (
              <span
                dangerouslySetInnerHTML={{ __html: promo.descriptionShortHtml }}
              />
            )}
            {promo.endAt && promo.timer && (
              <Countdown
                className={css.timer}
                endAt={promo.endAt}
                onEnd={() => showSet(false)}
              />
            )}
          </span>
        )}
      </Link>
      <Button
        appearance="transparent"
        className={css.close}
        color="dark"
        icon={<CrossIcon />}
        size="inner"
        onClick={hide}
      />
    </div>
  );
};

export default PromoTopAlert;
